/* GT Phase 5 blocks (10 Oct 2026). Home + How it works only. No libraries.
   1. Steps: once the step list is on screen, each card's layered illustration plays in turn (CSS holds it paused until .is-go).
   2. How it works hero: flavour chips re-theme the page (html[data-gx-f], html[data-gt-base]) and play the stage:
      pack, tear, Mix, Freeze, Churn, pack. Plays once after load when on screen, on every chip tap and on Play again.
      Tap the stage or press Esc to skip. Reduced motion: chips re-theme, nothing plays. */
(()=>{
  const d=document,R=matchMedia("(prefers-reduced-motion: reduce)").matches,$$=(s,r)=>[...(r||d).querySelectorAll(s)];

  const seq=$$("[data-gx-seq]"),go=l=>$$(":scope > li",l).forEach((li,i)=>setTimeout(()=>li.classList.add("is-go"),R?0:250+i*700));
  if(R||!("IntersectionObserver"in window))seq.forEach(go);
  else{const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){io.unobserve(e.target);go(e.target)}}),{threshold:.35});seq.forEach(l=>io.observe(l))}

  const H=d.querySelector("[data-gx-hero]");if(!H)return;
  const st=H.querySelector("[data-gx-stage]"),root=d.documentElement,chips=$$("[data-gx-pick]",H),rp=H.querySelector("[data-gx-replay]");
  let T=[],live=!1,ran=!1,tok=0;
  const clear=()=>{T.forEach(clearTimeout);T=[]},
    at=(ms,f)=>T.push(setTimeout(f,ms)),
    step=v=>{st.setAttribute("data-step",v);H.setAttribute("data-gx-step",v)},
    pack=()=>st.querySelector('[data-gx-pack="'+root.getAttribute("data-gx-f")+'"]')||st.querySelector("[data-gx-default]"),
    untear=()=>$$(".gx-tear",st).forEach(t=>t.remove()),
    end=()=>{clear();untear();step("0");st.classList.remove("is-run");live=!1;if(rp&&!R)rp.hidden=!1},
    play=()=>{
      if(R)return;clear();tok++;untear();ran=!0;live=!0;st.classList.add("is-run");step("0");
      $$(".gx-stage__step svg.gt-anim",st).forEach(s=>s.replaceWith(s.cloneNode(!0)));
      at(350,()=>{const img=pack()&&pack().querySelector("img");if(img){const c=img.cloneNode();c.className="gx-tear";c.alt="";c.removeAttribute("loading");c.removeAttribute("fetchpriority");img.parentNode.appendChild(c)}step("tear")});
      at(900,()=>step("1"));at(2050,()=>step("2"));at(3200,()=>step("3"));at(4350,end)
    },
    sync=k=>chips.forEach(c=>c.setAttribute("aria-pressed",c.dataset.gxPick===k?"true":"false")),
    pick=c=>{
      const k=c.dataset.gxPick;root.setAttribute("data-gx-f",k);if(c.dataset.base)root.setAttribute("data-gt-base",c.dataset.base);sync(k);
      try{const u=new URL(location.href);u.searchParams.set("flavour",k);history.replaceState(history.state,"",u)}catch(e){}
      if(R)return;clear();const id=++tok;
      const img=pack()&&pack().querySelector("img");
      if(img&&!img.complete){img.loading="eager";let done=!1;const once=()=>{if(!done&&id===tok){done=!0;play()}};img.addEventListener("load",once,{once:!0});at(700,once)}else play()
    };
  sync(root.getAttribute("data-gx-f"));
  chips.forEach(c=>c.addEventListener("click",()=>pick(c)));
  st.addEventListener("click",e=>{if(live&&!e.target.closest("[data-gx-replay]"))end()});
  d.addEventListener("keydown",e=>{if(live&&e.key==="Escape")end()});
  rp&&rp.addEventListener("click",play);
  if(!R){const auto=()=>{if(ran)return;const r=st.getBoundingClientRect();r.top<innerHeight&&r.bottom>0&&play()};
    d.readyState==="complete"?setTimeout(auto,700):addEventListener("load",()=>setTimeout(auto,700),{once:!0})}
})();
